export interface Fields {
  addedAttributes: any[];
  allAggregationProperties: any;
  allColumns: any[];
  fields: any;
  generatedEnabled: boolean;
  ideaColumns: any[];
  ideaDefaultSortColumn: string | null;
  ideaInfoTabsConfig: any;
  impactAggregationProperties: any;
  mainPageName: string;
  perspectiveConfigurations: any[];
  showWhatsNewBanner: boolean | null;
}

export interface FieldCustomizations {
  account: any;
  accountAdditionalInfo: any;
  allComponents: any[];
  businessCategoryMapping: any;
  c360FiltersConfig: any;
  components: any;
  customEvidenceObj: any;
  markedDeliveryStatus: any;
  enableEditOnImportedIdeas: boolean;
  enableIdeaValidation: boolean;
  overwriteIdeaStatusWithLinkedDelivery: boolean;
  gtmAppsConfiguration: any | null;
  ideaPriorities: any;
  ideaStatuses: any;
  objectCustomizations: any;
  opportunityAdditionalInfo: any;
  priorityData: any;
  quarterConfig: {
    _id?: { $oid: string };
    accountId?: { $oid: string };
    type?: string;
    name?: string;
    firstQuarterStartMonth?: number;
    firstQuarterStartDay?: number;
  } | null;
  requestPriorities: any;
  threeSixtyColumns: any[];
  threeSixtyConfig: any;
  threeSixtyEnabled: boolean;
}

export const initialFields: Fields = {
  addedAttributes: [],
  allAggregationProperties: [],
  allColumns: [],
  fields: null,
  generatedEnabled: false,
  ideaColumns: [],
  ideaDefaultSortColumn: null,
  ideaInfoTabsConfig: {},
  impactAggregationProperties: [],
  mainPageName: 'Main',
  perspectiveConfigurations: [],
  showWhatsNewBanner: null
};

export const initialFieldCustomizations: FieldCustomizations = {
  account: null,
  accountAdditionalInfo: null,
  allComponents: [],
  businessCategoryMapping: null,
  c360FiltersConfig: {},
  components: [],
  customEvidenceObj: null,
  markedDeliveryStatus: [],
  enableEditOnImportedIdeas: false,
  enableIdeaValidation: false,
  overwriteIdeaStatusWithLinkedDelivery: false,
  gtmAppsConfiguration: null,
  ideaPriorities: [],
  ideaStatuses: [],
  objectCustomizations: {},
  opportunityAdditionalInfo: null,
  priorityData: null,
  quarterConfig: null,
  requestPriorities: [],
  threeSixtyColumns: [],
  threeSixtyConfig: {},
  threeSixtyEnabled: false
};

export const processFields = (fields: any[]) => {
  const fieldAdditionalInfoObj: any = {};
  if (fields) {
    for (const k in fields) {
      if (fields[k].isExtra) {
        fieldAdditionalInfoObj[k] = fields[k];
      }
    }
  }
  return fieldAdditionalInfoObj;
}

export const handleFlagsData = (flags: any[]) => {
  let enableEditOnImportedIdeas = false;
  let enableIdeaValidation = false;

  if (flags?.length > 0) {
    flags.forEach((flag: any) => {
      if ( typeof flag.value === 'boolean') {
        if (flag.name === "enableEditOnImportedIdeas") {
          enableEditOnImportedIdeas = flag.value;
        }
        if (flag.name === "enableIdeaValidation") {
          enableIdeaValidation = flag.value;
        }
      }
    })
  }

  return {
    enableEditOnImportedIdeas,
    enableIdeaValidation
  }
}

export const sortData = (data: any[]) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.sort((a: any, b: any) => a.index - b.index);
};